var HomepageCarousel, carouselIntervalInstance,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

carouselIntervalInstance = null;

module.exports = HomepageCarousel = (function() {
  function HomepageCarousel(arg) {
    var ref, ref1, showSubnavWidget;
    ref = arg != null ? arg : {}, this.carouselConfig = ref.carouselConfig, this.showFreeShippingModal = ref.showFreeShippingModal;
    this._startCarousel = bind(this._startCarousel, this);
    this.widget = $("#carousel-widget");
    this.wrapper = this.widget.find("#carousel-wrapper");
    this.length = this.wrapper.children().length - 1;
    this.index = 0;
    this.advance = true;
    if (this.carouselConfig != null) {
      ref1 = this.carouselConfig, this.carouselInterval = ref1.carouselInterval, this.numOfSlots = ref1.numOfSlots, showSubnavWidget = ref1.showSubnavWidget, this.overlayControls = ref1.overlayControls, this.maxNumOfMenuItems = ref1.maxNumOfMenuItems, this.maxNumOfMenuCols = ref1.maxNumOfMenuCols, this.moreCategoriesId = ref1.moreCategoriesId;
      this.maxNumOfSubnavItems = this.numOfSlots;
      if (showSubnavWidget) {
        this.maxNumOfSubnavItems = this.numOfSlots - 1;
      }
    }
    this.menuItemHeight = 28;
    this.menuTopPadding = 3;
    this.moreCategoriesLabel = I18n.translate('js.modules.home.more_categories');
    if (this.showFreeShippingModal) {
      this._loadFreeShippingModal();
    }
    if ($("#homepage-header").length && $("#homepage-header-temp").length) {
      $("#homepage-header-temp").children().appendTo("#homepage-header");
    }
    if (this.widget.length) {
      if (this._hasNoControls()) {
        $("#homepage-header").addClass('carousel-height-no-controls');
      } else {
        $("#homepage-header").addClass('carousel-height');
      }
    }
    if (this.widget.length) {
      this._initializeCarousel();
      if (!$('html').hasClass('lt-ie9' && this.wrapper.children().length > 1)) {
        carouselIntervalInstance = setTimeout(this._startCarousel, this.carouselInterval);
      }
      this._loadControls();
      this._loadSubnav();
    }
  }

  HomepageCarousel.prototype._hasNoControls = function() {
    return this.wrapper.children().length === 1 || this.overlayControls;
  };

  HomepageCarousel.prototype._initializeCarousel = function() {
    var child, circles;
    child = this.wrapper.children().get(0);
    if (child) {
      $(child).css("opacity", 1).css("display", "block");
    }
    circles = this.widget.find(".icon-circle");
    if (circles.length) {
      return $(circles[0]).addClass("selected");
    }
  };

  HomepageCarousel.prototype._startCarousel = function() {
    this._advanceCarousel("right");
    return carouselIntervalInstance = setTimeout(this._startCarousel, this.carouselInterval);
  };

  HomepageCarousel.prototype._advanceCarousel = function(direction) {
    var prevIndex;
    prevIndex = this.index;
    this._incrementIndex(direction);
    if (prevIndex !== this.index) {
      this._showSlide(prevIndex, this.index);
      return this._showCircle(prevIndex, this.index);
    }
  };

  HomepageCarousel.prototype._jumpCarousel = function(from, to) {
    if (from !== to) {
      this._showSlide(from, to);
      this._showCircle(from, to);
      return this.index = to;
    }
  };

  HomepageCarousel.prototype._stopCarousel = function() {
    return carouselIntervalInstance = window.clearInterval(carouselIntervalInstance);
  };

  HomepageCarousel.prototype._incrementIndex = function(direction) {
    if (direction === 'right') {
      this.index += 1;
      if (this.index > this.length) {
        return this.index = 0;
      }
    } else {
      this.index -= 1;
      if (this.index < 0) {
        return this.index = this.length;
      }
    }
  };

  HomepageCarousel.prototype._showSlide = function(from, to) {
    var children;
    if (from !== to) {
      children = this.wrapper.children();
      from = $(children.get(from));
      to = $(children.get(to));
      from.fadeTo('fast', 0);
      to.fadeTo('fast', 1);
      return from.hide();
    }
  };

  HomepageCarousel.prototype._showCircle = function(from, to) {
    var circles;
    if (from !== to) {
      circles = this.widget.find(".icon-circle");
      if (circles.length) {
        $(circles[from]).removeClass("selected");
        return $(circles[to]).addClass("selected");
      }
    }
  };

  HomepageCarousel.prototype._loadFreeShippingModal = function() {
    if (window.GIG) {
      return window.GIG.init();
    }
  };

  HomepageCarousel.prototype._loadControls = function() {
    $('.homepage-carousel-left').on('click', (function(_this) {
      return function(e) {
        _this.advance = false;
        _this._stopCarousel();
        return _this._advanceCarousel('left');
      };
    })(this));
    $('.homepage-carousel-right').on('click', (function(_this) {
      return function(e) {
        _this.advance = false;
        _this._stopCarousel();
        return _this._advanceCarousel('right');
      };
    })(this));
    $('.carousel-item, .nav-bar-item, .menu').on('mouseenter', (function(_this) {
      return function(e) {
        return _this._stopCarousel();
      };
    })(this));
    $('.carousel-item, .nav-bar-item, .menu').on('mouseleave', (function(_this) {
      return function(e) {
        _this._stopCarousel();
        if (_this.advance) {
          return carouselIntervalInstance = setTimeout(_this._startCarousel, _this.carouselInterval);
        }
      };
    })(this));
    return $('.icon-circle').on('click', (function(_this) {
      return function(e) {
        var from, ref, ref1, ref2, to;
        to = parseInt((ref = e.target) != null ? (ref1 = ref.attributes) != null ? (ref2 = ref1.getNamedItem("index")) != null ? ref2.value : void 0 : void 0 : void 0, 10);
        from = _this.index;
        if (from !== to) {
          _this._stopCarousel();
          return _this._jumpCarousel(from, to);
        }
      };
    })(this));
  };

  HomepageCarousel.prototype._numOfCols = function(numOfItems) {
    return Math.ceil(numOfItems / this.maxNumOfMenuItems);
  };

  HomepageCarousel.prototype._numOfItemsPerCol = function(numOfItems, numOfCols) {
    return Math.ceil(numOfItems / numOfCols);
  };

  HomepageCarousel.prototype._flyoutPosition = function(navBarItemPos, numOfItemsPerCol) {
    var pos;
    pos = numOfItemsPerCol <= 1 ? 0 : Math.floor(numOfItemsPerCol / 2) - 1;
    if (pos > navBarItemPos) {
      return navBarItemPos;
    } else {
      return pos;
    }
  };

  HomepageCarousel.prototype._indexStartingFromEnd = function(navBarItemPos) {
    return (this.numOfSlots - 1) - navBarItemPos;
  };

  HomepageCarousel.prototype._calculateMenuTop = function(flyoutPosition) {
    return (this.menuItemHeight * flyoutPosition) + this.menuTopPadding;
  };

  HomepageCarousel.prototype._setMenuTop = function(menu, menuHoverContainer, menuTop) {
    menu.css('top', -menuTop + 'px');
    return menuHoverContainer.css('top', -menuTop + 'px');
  };

  HomepageCarousel.prototype._repositionMenu = function(menu, menuHoverContainer, navBarItemPos, numOfItemsPerCol) {
    var flyoutPosition, menuTop, newFlyoutPos, newNavBarItemPos;
    flyoutPosition = this._flyoutPosition(navBarItemPos, numOfItemsPerCol);
    menuTop = this._calculateMenuTop(flyoutPosition);
    if (navBarItemPos < (this.numOfSlots / 2)) {
      if (flyoutPosition <= navBarItemPos) {
        this._setMenuTop(menu, menuHoverContainer, menuTop);
      }
    } else {
      newFlyoutPos = (numOfItemsPerCol - 1) - flyoutPosition;
      newNavBarItemPos = this._indexStartingFromEnd(navBarItemPos);
      if (newFlyoutPos > newNavBarItemPos) {
        flyoutPosition = (numOfItemsPerCol - 1) - newNavBarItemPos;
        menuTop = this._calculateMenuTop(flyoutPosition);
      }
      this._setMenuTop(menu, menuHoverContainer, menuTop);
    }
    return menu.addClass('flyout-pos' + flyoutPosition);
  };

  HomepageCarousel.prototype._updateMenuWidth = function(menu, numOfCols) {
    if (numOfCols > this.maxNumOfMenuCols) {
      numOfCols = this.maxNumOfMenuCols;
    }
    return menu.addClass('columns-' + numOfCols);
  };

  HomepageCarousel.prototype._createCol = function(colNum, menu, numOfItemsPerCol, menuItems) {
    var colEnd, colStart, column, j, len, menuItem, ref, results;
    menu.append("<div class='menu-column'><ul></ul></div>");
    column = menu.find("ul")[colNum];
    colStart = colNum * numOfItemsPerCol;
    colEnd = colStart + numOfItemsPerCol;
    ref = menuItems.slice(colStart, colEnd);
    results = [];
    for (j = 0, len = ref.length; j < len; j++) {
      menuItem = ref[j];
      results.push($(column).append(menuItem));
    }
    return results;
  };

  HomepageCarousel.prototype._createCols = function(numOfCols, menu, numOfItemsPerCol, menuItems) {
    var i, j, ref, results;
    results = [];
    for (i = j = 0, ref = numOfCols - 1; j <= ref; i = j += 1) {
      if (i === this.maxNumOfMenuCols) {
        break;
      }
      results.push(this._createCol(i, menu, numOfItemsPerCol, menuItems));
    }
    return results;
  };

  HomepageCarousel.prototype._formatMenu = function(navBarItemPos, el) {
    var menu, menuHoverContainer, menuItems, numOfCols, numOfItems, numOfItemsPerCol;
    menu = $(el).find('.menu');
    menuHoverContainer = $(el).find('.menu-hover-container');
    menuItems = menu.find('.menu-item');
    numOfItems = menuItems.length;
    numOfCols = this._numOfCols(numOfItems);
    numOfItemsPerCol = this._numOfItemsPerCol(numOfItems, numOfCols);
    this._repositionMenu(menu, menuHoverContainer, navBarItemPos, numOfItemsPerCol);
    if (numOfItems > this.maxNumOfMenuItems) {
      menu.empty();
      this._updateMenuWidth(menu, numOfCols);
      this._createCols(numOfCols, menu, numOfItemsPerCol, menuItems);
    }
    return menuHoverContainer.height(menu.outerHeight());
  };

  HomepageCarousel.prototype._appendL2Category = function(menu, itemPos, el, menuItems) {
    var bhc, li, navBarLabel, title, url;
    navBarLabel = $(el).find('.nav-bar-label');
    bhc = navBarLabel.attr('data-bhc');
    title = navBarLabel.text().trim();
    url = $(el).find('a').attr('href');
    menu.append("<li class='menu-item' data-bhc='" + bhc + "'><a href='" + url + "'>" + title + "</a></li>");
    li = $(menu.find('li')[itemPos]);
    return menuItems.push(li);
  };

  HomepageCarousel.prototype._moreCategoriesNavBarItem = function(el) {
    var moreCategoriesLabel, moreCategoriesLink;
    $(el).attr('id', this.moreCategoriesId);
    moreCategoriesLink = $(el).find('a')[0];
    $(moreCategoriesLink).removeAttr('href');
    moreCategoriesLabel = $(el).find('.nav-bar-label');
    $(moreCategoriesLabel).attr('data-bhc', 'category:' + this.moreCategoriesId);
    $(moreCategoriesLabel).attr('data-bhc-path', 'LeftNavCategories|category:' + this.moreCategoriesId);
    return $(moreCategoriesLabel).html(this.moreCategoriesLabel);
  };

  HomepageCarousel.prototype._moreCategoriesMenu = function(moreCategories) {
    var i, j, menu, menuHoverContainer, menuItems, numOfCols, numOfItems, numOfItemsPerCol, ref;
    numOfItems = moreCategories.length;
    numOfCols = this._numOfCols(numOfItems);
    numOfItemsPerCol = this._numOfItemsPerCol(numOfItems, numOfCols);
    menu = $('#' + this.moreCategoriesId).find('.menu');
    menuHoverContainer = $('#' + this.moreCategoriesId).find('.menu-hover-container');
    menu.attr('class', 'menu arrow').empty();
    menuItems = [];
    for (i = j = 0, ref = numOfItems - 1; 0 <= ref ? j <= ref : j >= ref; i = 0 <= ref ? ++j : --j) {
      this._appendL2Category(menu, i, moreCategories[i], menuItems);
    }
    this._createCols(numOfCols, menu, numOfItemsPerCol, menuItems);
    return this._repositionMenu(menu, menuHoverContainer, this.maxNumOfSubnavItems - 1, numOfItemsPerCol);
  };

  HomepageCarousel.prototype._loadSubnav = function() {
    var el, hasMoreCategories, i, j, lastl2CategorySlot, len, moreCategories, navBarItems;
    moreCategories = [];
    navBarItems = $('.nav-bar-item');
    lastl2CategorySlot = this.maxNumOfSubnavItems - 1;
    hasMoreCategories = navBarItems.length > this.maxNumOfSubnavItems;
    for (i = j = 0, len = navBarItems.length; j < len; i = ++j) {
      el = navBarItems[i];
      if (hasMoreCategories && i >= lastl2CategorySlot) {
        moreCategories.push($(el).clone());
        if (i === lastl2CategorySlot) {
          this._moreCategoriesNavBarItem(el);
        } else {
          $(el).remove();
        }
      }
      this._formatMenu(i, el);
    }
    if (moreCategories.length > 0) {
      return this._moreCategoriesMenu(moreCategories);
    }
  };

  return HomepageCarousel;

})();

//# sourceMappingURL=data:application/json;base64,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
